import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  // timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('aidoo_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const customApi = async ({ method, url, isToken, data, params, isForm }) => {
  try {
    let token = '';
    if (isToken) {
      token = localStorage.getItem(`aidoo_token`);
    }

    const headers = {
      authorization: token ? token : undefined,
      'Content-Type': isForm ? 'multipart/form-data' : 'application/json',
    };

    const response = await apiClient({
      method,
      url,
      headers,
      data,
      params : params ? params : undefined
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error.response.data;
  }
};

export { customApi };
